export default "__VITE_ASSET__r6Qwt5sz__"